module.exports = __webpack_public_path__ + "img/bid02.bc175236.png";